import produce from 'immer';
import {
  SET_SAFETY_PROJECTS,
  CREATE_SAFETY_PROJECT,
  UPDATE_SAFETY_PROJECT,
  DELETE_SAFETY_PROJECT,
  SET_DAILY_FORMS,
  SET_DAILY_FORM_DETAIL,
  SET_SKYCLIMBER_FORMS,
  SET_SKYCLIMBER_FORM_DETAIL,
  SET_TOOLBOX_TALKS,
  UPDATE_TOOLBOX_TALK,
  CREATE_TOOLBOX_TALK,
  SET_SAFETY_DOCUMENTS,
  UPDATE_SAFETY_DOCUMENT,
  CREATE_SAFETY_DOCUMENT,
  SET_SAFETY_REPORT,
  SET_SAFETY_CONFIGS,
  CREATE_SAFETY_CONFIG,
  UPDATE_SAFETY_CONFIG,
  DELETE_SAFETY_CONFIG
} from '../constants/safety';
import { LOGOUT } from '../constants/auth';

const INIT_STATE = {
  safetyProjects: null,
  dailyForms: null,
  dailyFormDetail: null,
  skyclimberForms: null,
  skyclimberFormDetail: null,
  toolboxTalks: null,
  safetyDocuments: null,
  safetyReport: null,
  safetyConfigs: null
};

export default produce((draft, action) => {
  switch (action.type) {
    case SET_SAFETY_PROJECTS:
    case CREATE_SAFETY_PROJECT:
    case UPDATE_SAFETY_PROJECT:
    case DELETE_SAFETY_PROJECT:
      draft.safetyProjects = action.payload;
      break;
    case SET_DAILY_FORMS:
      draft.dailyForms = action.payload;
      break;
    case SET_DAILY_FORM_DETAIL:
      draft.dailyFormDetail = action.payload;
      break;
    case SET_SKYCLIMBER_FORMS:
      draft.skyclimberForms = action.payload;
      break;
    case SET_SKYCLIMBER_FORM_DETAIL:
      draft.skyclimberFormDetail = action.payload;
      break;
    case SET_TOOLBOX_TALKS:
    case UPDATE_TOOLBOX_TALK:
    case CREATE_TOOLBOX_TALK:
      draft.toolboxTalks = action.payload;
      break;
    case SET_SAFETY_DOCUMENTS:
    case UPDATE_SAFETY_DOCUMENT:
    case CREATE_SAFETY_DOCUMENT:
      draft.safetyDocuments = action.payload;
      break;
    case SET_SAFETY_REPORT:
      draft.safetyReport = action.payload;
      break;
    case SET_SAFETY_CONFIGS:
    case CREATE_SAFETY_CONFIG:
    case UPDATE_SAFETY_CONFIG:
    case DELETE_SAFETY_CONFIG:
      draft.safetyConfigs = action.payload;
      break;
    case LOGOUT:
      return INIT_STATE;
    default:
      return draft;
  }
}, INIT_STATE);
